export default __webpack_public_path__ + "static/media/bscarmy.9d8883a9.png";